// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackAddProductToQuickOrderParameters extends TrackEventBaseParameters {}

const trackAddProductToQuickOrder = (
    parameters: TrackAddProductToQuickOrderParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "add_product_to_quick_order", ...parameters }, options);
};

export default trackAddProductToQuickOrder;
